<!--月度业绩目标-->
<template>
  <div class="app-container">
    <el-card class="box-card">
      <dynamic-search :data="tableFilterList(tableHead)" @search="dataTableSearch">
        <template v-slot:next>
          <!-- v-if="!isAdmin"  -->
          <el-button icon="el-icon-plus" @click="add()">新增</el-button>
          <!-- <el-button icon="el-icon-plus" :disabled="isDisabled" @click="exportList()">批量导出</el-button> -->
          <el-button icon="el-icon-upload1" @click="exportDataList()" v-if="isAdmin">导出</el-button>
        </template>
      </dynamic-search>
      <edit-data-table
        :head="tableHead"
        :data.sync="list"
        :editable="false"
        :total="total"
        :offset="offset"
        :page="page"
        :loading="loading"
        stripe
        border
        @handlePageChange="dataTablePageChange"
        @handleSizeChange="dataTableSizeChange"
      >
        <template #changeType="{row}">
          <div v-for="item in changeTypeStatus" :key="item.id">
            <div v-if="row.changeType.toString() === item.value">{{item.label}}</div>
          </div>
        </template>
        <template #status="{row}">
          <el-tag v-if="row.status === 0">草稿</el-tag>
          <el-tag v-if="row.status === 1" type="success">已提交</el-tag>
          <el-tag v-if="row.status === 2" type="danger">已作废</el-tag>
        </template>
        <template #toolbar="scope">
          <el-button
          class="margin-top"
            type="primary"
            size="mini"
            slot="reference"
            @click="edit(scope.row.id,false)"
            >查看<i class="el-icon-view el-icon--right"></i></el-button>
            <el-button
            class="margin-top"
             v-if="scope.row.status === 0"
              type="info"
              size="mini"
              slot="reference"
              @click="edit(scope.row.id,true)"
              >编辑<i class="el-icon-edit el-icon--right"></i></el-button>
          <el-popover
            :ref="scope.row.id + 'b'"
            v-if="scope.row.status === 0"
            placement="top"
            width="180"
          >
            <p>确定要提交吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'b'].doClose()"
                >取消</el-button
              >
              <el-button
                type="primary"
                size="mini"
                @click="operation(scope.row.id,'submit')"
                >确定
              </el-button>
            </div>
            <el-button
            class="margin-top"
              type="success"
              size="mini"
              slot="reference"
              >提交<i class="el-icon-check el-icon--right"></i></el-button
            >
          </el-popover>
          <el-popover
            :ref="scope.row.id + 'd'"
            v-if="scope.row.status === 1"
            placement="top"
            width="180"
          >
            <p>确定要作废吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'd'].doClose()"
                >取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="operation(scope.row.id,'cancel')"
                >确定</el-button>
            </div>
            <el-button
            class="margin-top"
              v-if="isAdmin"
              type="warning"
              size="mini"
              slot="reference"
              >作废<i class="el-icon-close el-icon--right"></i></el-button>
          </el-popover>
          <el-popover
            :ref="scope.row.id + 'c'"
            v-if="scope.row.status === 0"
            placement="top"
            width="180"
          >
            <p>确定要删除吗</p>
            <div style="text-align: right; margin: 0">
              <el-button
                size="mini"
                type="text"
                @click="$refs[scope.row.id + 'c'].doClose()"
                >取消</el-button>
              <el-button
                type="primary"
                size="mini"
                @click="operation(scope.row.id,'delete')"
                >确定</el-button>
            </div>
            <el-button
              class="margin-top"
              v-if="scope.row.status === 0"
              type="danger"
              size="mini"
              slot="reference"
              >删除<i class="el-icon-delete el-icon--right"></i></el-button>
          </el-popover>
        </template>
      </edit-data-table>
    </el-card>
  </div>
</template>

<script>
import "@/components/EditDataTable";
import DynamicSearch from "@/components/DynamicSearch";
import DataTableMixin from "@/mixins/DataTableMixin";
import { delMonthKpi, cancelMonthKpi,submitMonthKpi, exportListDataExcel} from "@/api/bill/monthkpi";
import { tableSataus } from '@/views/bill/mixins/status'

export default {
  name: "MoneyKpiList",
  components: {
    DynamicSearch
  },
  mixins: [DataTableMixin, tableSataus],
  data () {
    return {
      changeTypeStatus: [],
      tableHead: [
        {
          label: '创建时间',
          prop: "created"
        },
        {
          label: "所属部门",
          prop: "deptName",
          query: {
            type: "input"
          },
        },
        {
          label: "姓名",
          prop: "personName",
          query: {
            type: "input"
          },
        },
        {
          label: "业绩月度",
          prop: "monthly",
          query: {
            type: "input"
          },
        },
        {
          label: "状态",
          prop: "status"
        }
      ]
    }
  },
  created () {
    this.$nextTick(() => {
      this.dataTableInit()
    });
  },
  methods: {
    exportDataList() {
      exportListDataExcel()
    },
    dataTableBeforeInit () {
      this._url = "/monthkpi"
      const params = { page: this.page, size: this.offset }
      this._params = Object.assign(params, this._query)
      return true
    },
    add() {
      this.$router.push({name: "MonthKpiForm"})
    },
    edit(id,isEdit) {
       this.$router.push({name: "MonthKpiForm",params: {id: id,isEdit: isEdit}})
    },
    operation(id,type) {
      let request = null;
      if (type === 'delete') {
        request = delMonthKpi
      } else if (type === 'submit') {
        request = submitMonthKpi
      } else if (type === 'cancel') {
        request = cancelMonthKpi
      }
      request(id).then((res) => {
        if (res.code === 200) {
          this.$notify({
            title: "操作成功！",
            type: "success",
            duration: 2500,
          });
         this.dataTableInit();
        }
      });
    },
  }
}
</script>

<style scoped lang="scss">
  .margin-top{
    margin-top: 5px;
    margin-bottom: 5px;
  }
</style>
